// WP-0.7 (§18.1 mobile): the "Menu (everything else)" sheet — reveals every navigation
// destination on phones, where the sidebar is hidden. Opened from the bottom-nav Menu tab.
import { X } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { NAV_SECTIONS } from '../routes/nav';
import { Icon } from './Icon';
import { Mark } from './Mark';

export function MobileMenu({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): React.JSX.Element | null {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex flex-col bg-surface sm:hidden"
      role="dialog"
      aria-label="Menu"
    >
      <div className="flex h-14 items-center justify-between border-b border-border px-4">
        <span className="flex items-center gap-2 font-semibold text-ink">
          <Mark size={20} />
          Menu
        </span>
        <button
          aria-label="Close menu"
          className="rounded-[var(--radius-control)] p-1.5 text-muted hover:bg-bg hover:text-ink"
          onClick={onClose}
        >
          <X size={20} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto py-2">
        {NAV_SECTIONS.map((section) => (
          <div key={section.group} className="mb-2">
            {section.label !== null && (
              <p className="px-4 pb-1 pt-2 text-xs font-medium uppercase tracking-wide text-muted">
                {section.label}
              </p>
            )}
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                onClick={onClose}
                className={({ isActive }) =>
                  `mx-2 flex items-center gap-3 rounded-[var(--radius-control)] px-3 py-3 text-sm ${
                    isActive ? 'bg-primary/10 text-primary' : 'text-ink hover:bg-bg'
                  }`
                }
              >
                <Icon name={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
